<template>
  <transition name="fade" appear>
    <div class="guests-modal" @click="$emit('close')">
      <div @click.stop.prevent>
        <div>
          <h2><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <path d="M17.1274 11.6587C17.1274 12.5739 16.856 13.4685 16.3475 14.2295C15.8391 14.9905 15.1164 15.5836 14.2708 15.9338C13.4253 16.2841 12.4949 16.3757 11.5972 16.1971C10.6996 16.0186 9.87509 15.5779 9.22793 14.9307C8.58078 14.2836 8.14006 13.459 7.96151 12.5614C7.78296 11.6638 7.8746 10.7334 8.22484 9.88782C8.57508 9.04227 9.16818 8.31957 9.92916 7.81111C10.6901 7.30264 11.5848 7.03125 12.5 7.03125C13.7273 7.03125 14.9043 7.51878 15.7721 8.38658C16.6399 9.25439 17.1274 10.4314 17.1274 11.6587ZM23.4375 12.5C23.4375 14.6632 22.796 16.7779 21.5942 18.5765C20.3924 20.3752 18.6842 21.7771 16.6856 22.6049C14.687 23.4328 12.4879 23.6494 10.3662 23.2273C8.24454 22.8053 6.29566 21.7636 4.76602 20.234C3.23639 18.7043 2.19469 16.7555 1.77267 14.6338C1.35064 12.5121 1.56724 10.313 2.39507 8.3144C3.22291 6.31583 4.62479 4.60763 6.42345 3.4058C8.22212 2.20397 10.3368 1.5625 12.5 1.5625C15.3991 1.56806 18.1779 2.72218 20.2278 4.77216C22.2778 6.82213 23.4319 9.6009 23.4375 12.5ZM21.7548 12.5C21.7554 11.0011 21.3918 9.52445 20.6955 8.1971C19.9991 6.86974 18.9908 5.73139 17.7572 4.87993C16.5236 4.02846 15.1016 3.48937 13.6136 3.30901C12.1256 3.12865 10.616 3.31242 9.21469 3.84452C7.81339 4.37661 6.5623 5.2411 5.56901 6.36366C4.57571 7.48621 3.86993 8.83323 3.51237 10.2889C3.15481 11.7445 3.15616 13.2653 3.51632 14.7203C3.87647 16.1753 4.58464 17.521 5.57993 18.6418C6.26098 17.6649 7.1386 16.841 8.15655 16.223C9.32534 17.3427 10.8814 17.9678 12.5 17.9678C14.1186 17.9678 15.6747 17.3427 16.8435 16.223C17.8614 16.841 18.739 17.6649 19.4201 18.6418C20.9268 16.9511 21.7579 14.7646 21.7548 12.5Z" fill="white" />
            </svg>
            <span>Guest Details</span>
          </h2>
        </div>
        <div class="guests-headers">
          <p></p>
          <p>First Name*</p>
          <p>Last Name*</p>
          <p>Email Address</p>
          <p></p>
        </div>
        <div class="guests-info">
          <GuestInfo v-for="(guest, id) in guests" :guest="id" :info="guest" @removeGuest="removeGuest" :key="guest" />
          <Button text="Add a Guest" link="" @click="
            $emit('addGuest');
          guests.push({ first: '', last: '', email: '' });
          " class="add-guest" v-show="numGuests < 3" />
        </div>
        <div class="appointment">
          <h2>Your Appointment is on<br /><span>{{ selectedBooking }}</span></h2>
        </div>
        <div class="ui">
          <Button text="Back" link="" @click="
            $emit('close');
          $emit('done', finalGuests());
          " />
          <Button text="Book Now" link="" @click="submitAppointment" :class="{ disabled: numGuests !== finalGuests().length }" class="submit" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import validator from 'validator';
  import GuestInfo from "@/components/GuestInfo";
  import Button from "@/components/Button";
  export default {
    name: "GuestModal",
    props: {
      numGuests: Number,
      currentGuestInfo: Array,
    },
    components: {
      GuestInfo,
      Button,
    },
    computed: {
      selectedBooking() {
        let dayOptions = {
          weekday: "short",
          month: "short",
          day: "numeric",
        };
        let timeOptions = {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        };

        let booking = new Date(this.$store.state.selectedBooking);
        return `${booking.toLocaleDateString("en-US", dayOptions)} at ${booking.toLocaleTimeString("en-US", timeOptions)}`;
      }
    },
    methods: {
      removeGuest(id) {
        this.guests.splice(id, 1);
        this.$emit("removeGuest");
        if (this.guests.length === 0) {
          this.$emit('close');
        }
      },
      submitAppointment() {
        if (this.numGuests !== this.finalGuests().length) {
          alert('Please enter your guests additional info.')
          return;
        }
        this.$emit('done', this.finalGuests());
        this.$emit('submitAppointment');
      },
      finalGuests() {
        let guests = this.guests.filter((guest) => {
          return (
            (guest.first.trim() !== "" && guest.last.trim() !== "") &&
            (guest.email.trim() === "" || (guest.email.trim() !== "" && validator.isEmail((guest.email.trim()))))
          );
        });
        return guests;
      },
    },
    mounted() {
      let guests = [];
      if (this.currentGuestInfo) {
        guests = this.currentGuestInfo;
      }
      for (let index = guests.length; index < this.numGuests; index++) {
        guests.push({ first: "", last: "", email: "" });
      }
      this.guests = guests;
    },
    data() {
      return {
        guests: [],
        testEmail: /^.+@.+\..+$/,
      };
    },
  };
</script>

<style lang="scss" scoped>
  button {
    &.disabled {
      opacity: 0.2;
    }
  }

  .add-guest {
    align-self: flex-start;

    @media (max-width:850px) {
      width: 100%;
    }
  }

  .guests-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    display: grid;
    place-items: center;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: var(--blue);
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--accent);
    }

    >div {
      overflow: hidden;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);
      border-radius: 6px;
      background: #F6F6F6;
    }
  }

  .guests-headers {
    padding: 0 15px;
    text-align: left;
    display: none;
    grid-template-columns: 75px 1fr 1fr 1fr 40px;
    gap: 5px;

    p {
      padding: 0 30px;
      color: var(--black);
      font-family: "proxima-nova", sans-serif;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.26px;
      text-transform: uppercase;
    }

    @media (min-width:850px) {
      display: grid;
    }
  }

  .guests-info {
    padding: 25px 15px;
    padding-top: 0;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 60vh;
    overflow: auto;
  }

  .ui {
    padding: 15px 0;
    display: flex;
    gap: 5px;
    justify-content: center;
  }

  h2 {
    background: var(--green);
    color: var(--white);
    font-family: "proxima-nova", sans-serif;
    font-size: 20px;
    font-weight: 800;
    text-transform: uppercase;
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 16px 22px;
    margin-top: 0;
  }

</style>